// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2eeea00faef457f4693aec732c65dc03c3ab6cca/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};